import type { Reducer } from 'redux';

import type {
  FeedPreloadInitiatedAction,
  FeedRenderedAction,
  ThreadPreloadInitiatedAction,
  ThreadRenderedAction,
} from '../../domains/pageLoad/actions.types';

import type { PageLoad } from './types';

export type PageLoadAction =
  | FeedPreloadInitiatedAction
  | ThreadPreloadInitiatedAction
  | FeedRenderedAction
  | ThreadRenderedAction;

const initialState = {
  hasThreadRendered: false,
  isPreloadingThread: false,

  preloadingFeedIds: [],
  renderedFeedIds: [],
};

const reducer: Reducer<PageLoad, PageLoadAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'PAGE.FEED_RENDERED':
      return {
        ...state,
        renderedFeedIds: state.renderedFeedIds.includes(action.feedId)
          ? state.renderedFeedIds
          : [...state.renderedFeedIds, action.feedId],
        preloadingFeedIds: state.preloadingFeedIds.filter((item) => item !== action.feedId),
      };
    case 'PAGE.THREAD_RENDERED':
      return {
        ...state,
        hasThreadRendered: true,
        isPreloadingThread: false,
      };
    case 'PAGE.FEED_PRELOAD_INITIATED':
      return {
        ...state,
        preloadingFeedIds: [...state.preloadingFeedIds, action.feedId],
      };
    case 'PAGE.THREAD_PRELOAD_INITIATED':
      return {
        ...state,
        isPreloadingThread: true,
      };
    default:
      return state;
  }
};

export default reducer;
